<template>
  <d-select
    type="text"
    :name="name"
    :id="id"
    :value="value"
    @input="updateSelectedValue($event)"
    >
    <option value="">{{ placeholder }}</option>
    <option
      v-for="option in options"
      :key="option.id"
      :value="option.id">
      {{ option.name }}
    </option>
  </d-select>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: [String, Number]
  },
  methods: {
    updateSelectedValue(newValue) {
      this.$emit('input', newValue); 
    }
  }
}
</script>